import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { StyledBody } from './Body/index.styles';
import { StyledRow } from './Row/index.styles';
export var HoveredStyledTable = function HoveredStyledTable(props) {
  return "\n    ".concat(StyledBody, " ").concat(StyledRow, ":hover {\n        background-color: ").concat(props.theme.components.table.hover, ";\n    }\n");
};
export var StyledTable = styled.table(_templateObject(), function (props) {
  return "\n        font-family: \"Montserrat\";\n        font-size: ".concat(props.theme.components.table.fontSize, ";\n        line-height: ").concat(props.theme.components.table.lineHeight, ";\n        color: ").concat(props.theme.components.table.color, ";\n        font-weight: ").concat(props.theme.components.table.fontWeight, ";\n        border-collapse: collapse;\n\n        ").concat(props.noHover ? '' : HoveredStyledTable(props), "\n    ");
});